// src/main.jsx
import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

// Tu app funcional (la que ya tienes con Keychain/NFC/Invoices)
import App from "./App.jsx";
// Landing informativo estilo LaCrypta (lo moviste a /pages)
import Landing from "./pages/Landing.jsx";

// Estilos globales de la app (buttons, modales, etc.)
// Nota: el landing importa su propio CSS: `./pages/landing.css` dentro de Landing.jsx
import "./styles.css";

// Helper para obtener el path actual
const getPath = () => window.location.pathname || "/";

// Mini enrutador sin dependencias
function Router() {
  const [path, setPath] = useState(getPath());

  useEffect(() => {
    const onPop = () => setPath(getPath());
    window.addEventListener("popstate", onPop);
    window.addEventListener("hashchange", onPop);
    return () => {
      window.removeEventListener("popstate", onPop);
      window.removeEventListener("hashchange", onPop);
    };
  }, []);

  // Rutas que deben cargar la App completa
  const isAppRoute =
    path.startsWith("/app") ||
    path.startsWith("/invoice") ||
    path.startsWith("/card");

  return isAppRoute ? <App /> : <Landing />;
}

createRoot(document.getElementById("root")).render(<Router />);

